import { Collapse, List, ListItem, ListItemIcon, ListItemText, IconButton, withStyles, StyledComponentProps, Divider } from '@material-ui/core';
import { Contact, Message } from '../../../../ui-components/Icons';
import * as React from 'react';
import { contact } from '../../../../model/contact';
import Tag from '../Tag/Tag';
import Room from '../Room/Room';
import { styles } from './styles';
import { ContactInfo } from './ContactInfo';
import ExpandDownButton from '../../../../ui-components/Button/ExpandDownButton';
import CollapseUpButton from '../../../../ui-components/Button/CollapseUpButton';
import moment from 'moment';

interface IContactItemProps extends StyledComponentProps {
    contact: contact;
    onContactClick: (sub: string) => void;
    navigateTo: (path: string) => void;
    isSelected: boolean;
    roomList: Array<string>;
}

interface IContactItemState {
    open: boolean;
    openRoom: boolean;
}

class ContactItem extends React.Component<IContactItemProps, IContactItemState> {

    state = { open: false, openRoom: false }

    private expandTags = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>, open: boolean, openRoom: boolean) => {
        this.setState({
            open: open,
            openRoom: open
        });
        evt.stopPropagation();
    }

    getRoomAccessStyle = () => {
        var enabled: number = 0;
        // console.log("this.props.roomList:", this.props.roomList);
        if (this.props.contact.rooms.length === 0)
            return { backgroundColor: 'transparent' }

        this.props.contact.rooms.map(room => {
            if (room.endDate !== undefined && moment(room.endDate).toDate() >= (new Date())) {
                enabled = enabled + 1;
            }
            return true;
        });
        return (enabled === 0 ? { backgroundColor: 'red' } : { backgroundColor: 'green' });
        // (enabled < this.props.contact.rooms.length ? { backgroundColor: 'green' } :
        //     { backgroundColor: 'green' }));
    }

    render() {
        const { contact, classes } = this.props;
        return (
            <>
                <ListItem button
                    onClick={(e) => this.props.onContactClick(this.props.contact.sub)}
                    className={this.props.isSelected ? classes.selectedContact : classes.contact}
                >
                    <ListItemIcon className={classes.userIcon}>
                        <Contact />
                    </ListItemIcon>
                    <ContactInfo contact={contact} classes={classes} />
                    {this.props.contact.rooms.length > 0 && <div className={classes.roomContactEnabled} style={this.getRoomAccessStyle()} />}
                    <IconButton
                        className={classes.messageIcon}
                        onClick={e => {
                            e.stopPropagation();
                            this.props.navigateTo(`/private/Chat/${this.props.contact.sub}`)
                        }
                        }>
                        <Message />
                    </IconButton>
                    {this.state.open ? <CollapseUpButton onClick={(evt) => this.expandTags(evt, false, false)} /> :
                        <ExpandDownButton onClick={(evt) => this.expandTags(evt, true, false)} />}

                </ListItem>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <List disablePadding>
                        <ListItem button>
                            <ListItemText className={classes.tagsContainer}
                                primary={this.props.contact.tags && this.props.contact.tags.map(t => <Tag key={t._id} tag={t} />)} key={this.props.contact._id} />
                        </ListItem>
                    </List>
                </Collapse>
                <Collapse in={this.state.openRoom} timeout="auto" unmountOnExit>
                    <div style={{ marginBottom: '10px' }}>
                        {this.props.contact.rooms && this.props.contact.rooms
                            .sort((a, b) => a.endDate < b.endDate ? 1 : -1)
                            .map(r => {
                                if (this.props.roomList.includes(r._id))
                                    return <Room key={r._id} myroom={r} />
                                else
                                    return <span key={r._id}></span>
                            })}
                    </div>
                    {/* <List disablePadding>
                        <ListItem button>
                            <ListItemText className={classes.roomsContainer} primary={this.props.contact.rooms && this.props.contact.rooms.map(r => <Room myroom={r} />)} key={this.props.contact._id} />
                        </ListItem>
                    </List> */}
                </Collapse>
                <Divider />
            </>
        );
    }
}

export default withStyles(styles)(ContactItem);